export function labelForm() {
    window.addEventListener( "DOMContentLoaded", function () {
        let $forms = $(".gform_wrapper");

        $forms.each( function () {
            let $form = $(this);
            let $inputs = $form.find("input[type='text'], input[type='password'], input[type='email'], input[type='number'], textarea");
            let $select = $form.find("select");
            let $textarea = $form.find("textarea");
            let $capcha = $(".ginput_recaptcha");
            let $loaderBlock = $(".ginput_preview");
            let getLabel = function (el) {
                let $inputParent = el.closest(".form-field");
                let $label = $inputParent.find(".gfield_label");
                return $label;
            };
            let hideLabel = function (input, hideAllTime) {
                if (getLabel(input)) {
                    let placeholder = getLabel(input);

                    if (hideAllTime) {
                        placeholder.addClass("hidden-label");
                    } else {
                        placeholder.addClass("hide");
                    }
                }
            };
            let showLabel = function (input) {
                if (getLabel(input)) {
                    let placeholder = getLabel(input);
                    placeholder.removeClass("hide");
                }
            };

            // hide label for select
            $select.each( function () {
                let $parentEl = $(this).closest(".form-field");
                let $capchaLabel = $parentEl.find(".gfield_label");
                $capchaLabel.addClass("hidden");
            });

            // hide label for textarea
            $textarea.each( function () {
                hideLabel($(this), true);
            });

            $capcha.each( function () {
                let $parentEl = $(this).closest(".gfield");
                let $capchaLabel = $parentEl.find(".gfield_label");
                $capchaLabel.addClass("hidden-label");
            });

            $inputs.each( function () {
                let $th = $(this);
                if ($th.val()) {
                    hideLabel($th);
                }

                // when tag LABEL is not defined need to show default placeholder or field has datepicker
                if (!getLabel($th).length || $th.hasClass("hasDatepicker")) {
                    $th.addClass("default-placeholder");

                    if ($th.hasClass("hasDatepicker")) {
                        hideLabel($th, true);
                    }
                }
            });

            $loaderBlock.each( function () {
                let $parent = $loaderBlock.closest(".ginput_container_fileupload");
                let $boxName = $parent.find(".file-field-box-name");
                $boxName.addClass("hidden");
            });

            $inputs.on("keyup", function (e) {
                let $th = $(this);
                if ($th.val() == "") {
                    showLabel($th);
                } else {
                    hideLabel($th);
                }
            });
        });
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/labelForm.js